export const services = [
  {
    slug: 'betonpumpe',
    title: 'Betonpumpenvermietung mit Fahrer',
    shortTitle: 'Betonpumpe',
    index: '01',
    headline: 'Betonpumpe mit Fahrer für Wien und Niederösterreich',
    metaTitle: 'Betonpumpe mit Fahrer Wien | MH-BETON',
    metaDescription: 'Betonpumpe mit erfahrenem Fahrer für Wien, Wien Umgebung und Niederösterreich. Effizientes Beton einbringen – auch an schwer erreichbare Stellen.',
    description: 'Für Einbringstellen, die mit Schubkarre oder Kran unnötig Zeit kosten: MH-BETON stellt Betonpumpe und erfahrenen Fahrer für den Einsatz bereit.',
    lead: 'Eine Betonpumpe bringt den Beton exakt dort hin, wo er gebraucht wird – schnell, sauber und mit erfahrenem Fahrer. Ideal für Rohbauten, Sanierungen, Hinterhöfe und alle Stellen, die per Schubkarre oder Kran nur schwer zu erreichen sind.',
    benefits: [
      'Baustellencheck vor der Einteilung',
      'Abstimmung von Zufahrt und Aufstellfläche',
      'Effizientes Pumpen an die gewünschte Stelle',
      'Erfahrener Fahrer inklusive',
      'Flexible Einsatzplanung für Wien & Niederösterreich',
    ],
    image: '/assets/img/reference-01.webp',
    imageAlt: 'Betonpumpe von MH-BETON im Wohnbau-Einsatz',
    keywords: ['Betonpumpe Wien', 'Betonpumpenvermietung Wien', 'Betonpumpe mit Fahrer Wien', 'Betonpumpe Wien Umgebung'],
    faq: [
      {
        question: 'Wie weit kann die Betonpumpe pumpen?',
        answer: 'Das kommt auf die Pumpe und den Pumpweg vor Ort an. Wir besprechen vor dem Einsatz die Entfernung von der Aufstellfläche bis zur Einbringstelle und prüfen, welche Lösung passt.',
      },
      {
        question: 'Brauche ich eine Genehmigung für die Betonpumpe?',
        answer: 'In den meisten Fällen nicht für private Grundstücke. Bei öffentlichem Raum oder Straßenabstellflächen klären wir das gerne im Vorfeld.',
      },
    ],
  },
  {
    slug: 'betontransport',
    title: 'Betontransport',
    shortTitle: 'Betontransport',
    index: '02',
    headline: 'Betontransport Wien und Niederösterreich',
    metaTitle: 'Betontransport Wien | Pünktliche Betonlieferung | MH-BETON',
    metaDescription: 'Zuverlässiger Betontransport für Wien, Wien Umgebung und Niederösterreich. Pünktliche Lieferung direkt zur Baustelle.',
    description: 'Pünktliche Lieferung direkt zur Baustelle, abgestimmt auf Projektgröße, Zeitfenster und die Bedingungen vor Ort.',
    lead: 'Wir bringen Beton zur richtigen Zeit an die richtige Stelle. Ob Innenstadt, Außenbezirk oder Niederösterreich – unsere Transportlogistik ist auf Baustellenabläufe abgestimmt, nicht auf den eigenen Fahrplan.',
    benefits: [
      'Für Wien, Wien Umgebung und Niederösterreich',
      'Koordination mit der Baustellenmannschaft',
      'Verlässliche Anlieferung statt Improvisation',
      'Abstimmung von Zeitfenster und Zufahrt',
      'Kombinierbar mit Betonpumpe und Betonverkauf',
    ],
    image: '/assets/img/reference-09.webp',
    imageAlt: 'Betontransport auf Baustelle in Wien',
    keywords: ['Betontransport Wien', 'Beton liefern lassen Wien', 'Betonlieferung Niederösterreich', 'Betontransport Wien Umgebung'],
    faq: [
      {
        question: 'In welchem Gebiet liefert MH-BETON Beton?',
        answer: 'Wir sind in Wien, Wien Umgebung und Niederösterreich im Einsatz. Bei größeren Projekten besprechen wir die Logistik individuell.',
      },
      {
        question: 'Wie pünktlich muss die Baustelle bereit sein?',
        answer: 'Beton will geplant werden. Wir abstimmen vorab Termin, Zufahrt und Entladezone, damit die Anlieferung reibungslos passt.',
      },
    ],
  },
  {
    slug: 'betonverkauf',
    title: 'Betonverkauf',
    shortTitle: 'Betonverkauf',
    index: '03',
    headline: 'Beton kaufen in Wien und Niederösterreich',
    metaTitle: 'Beton kaufen Wien | Betonverkauf | MH-BETON',
    metaDescription: 'Betonverkauf für private und gewerbliche Bauvorhaben in Wien und Niederösterreich. Passende Güte und Menge – mit Transport und Pumpe auf Wunsch.',
    description: 'Beton in passender Güte und Menge – verlässlich abgestimmt auf Bauvorhaben, Termin und Einbringung vor Ort.',
    lead: 'Wir verkaufen Beton passend zu Ihrem Projekt: in der richtigen Güte, der passenden Menge und mit Unterstützung bei der Planung. Auf Wunsch kombinieren wir den Betonverkauf direkt mit Transport und Betonpumpe.',
    benefits: [
      'Beton für private und gewerbliche Bauvorhaben',
      'Unterstützung bei der Bestellvorbereitung',
      'Auf Wunsch kombiniert mit Transport und Pumpe',
      'Abstimmung von Güte und Menge',
      'Beratung zu Termin und Einbringung',
    ],
    image: '/assets/img/reference-08.webp',
    imageAlt: 'Betonverkauf mit koordiniertem Ablauf',
    keywords: ['Beton kaufen Wien', 'Betonverkauf Wien', 'Beton für Baustelle Wien', 'Beton bestellen Wien'],
    faq: [
      {
        question: 'Welche Betongüte brauche ich?',
        answer: 'Das hängt von der Anwendung ab: Fundamente, Bodenplatten, Treppen oder Mauern haben unterschiedliche Anforderungen. Wir beraten Sie gerne.',
      },
      {
        question: 'Kann ich Betonmenge und Güte kombiniert anfragen?',
        answer: 'Ja. Sie können bei uns Beton, Transport und Pumpe gemeinsam planen. Das spart Abstimmungsaufwand und Fehlerquellen.',
      },
    ],
  },
];

export function getServiceBySlug(slug) {
  return services.find((service) => service.slug === slug);
}

export const serviceOptions = services.map((s) => ({
  value: s.slug,
  label: s.shortTitle,
}));
